<template>
  <div>
    <div v-if="comments && comments.length > 0">
      <div v-for="comment in comments" :key="comment.id">
        <v-card
          class="rounded-lg theme-shadow mb-3"
          :class="{
            customerCommentBoarder: comment.isCustomerComment,
            empoyeeCommentBoarder: !comment.isCustomerComment,
          }"
          :outlined="$vuetify.theme.dark"
        >
          <v-list :color="getBackgroundColor(comment)">
            <v-list-item class="pt-0 pb-0">
              <div class="d-flex flex-column align-self-start">
                <v-avatar size="40" class="mx-auto mr-2">
                  <!-- <v-img :src="getImageUrl(comment)"></v-img> -->
                  <v-img
                    v-if="!comment.isCustomerComment"
                    :lazy-src="
                      contactpersonApi.getProfilePhoto(
                        comment.commentedByEmailEkstern,
                        profileImageUpdate
                      )
                    "
                    :src="
                      contactpersonApi.getProfilePhoto(
                        comment.commentedByEmailEkstern,
                        profileImageUpdate
                      )
                    "
                    max-height="180"
                  />
                  <v-img
                    v-if="comment.isCustomerComment"
                    :src="getImageUrl(comment)"
                  ></v-img>
                </v-avatar>
              </div>
              <v-list-item-content class="pt-0 pb-0">
                <v-list-item-title class="d-flex justify-space-between">
                  <div v-if="comment.commentedByName">
                    <div>
                      {{ comment.commentedByName }}
                    </div>
                  </div>

                  <div class="d-flex caption align-center">
                    <div class="caption">
                      {{ comment.createdDate | moment("DD.MM.YYYY HH:mm") }}
                    </div>
                  </div>
                </v-list-item-title>

                <!-- subtitle -->
                <v-list-item-title class="d-flex justify-space-between">
                  <span class="caption">
                    {{ comment.isCustomerComment ? "Kunde" : "Ansatt" }}
                  </span>
                  <div class="d-flex caption align-center">
                    <!-- Customer have seen commetn in MT -->
                    <v-tooltip
                      v-if="
                        !comment.isCustomerComment && comment.visibleToCustomer
                      "
                      top
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mr-2"
                          :color="comment.readByCustomer ? 'primary' : 'gray'"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{
                            comment.readByCustomer ? "mdi-eye" : "mdi-eye-off"
                          }}
                        </v-icon>
                      </template>
                      <span>
                        {{
                          comment.readByCustomer
                            ? "Kunde har sett"
                            : "Kunde har ikke sett"
                        }}</span
                      >
                    </v-tooltip>
                    <v-chip x-small>
                      {{ comment.stringStatus }}
                    </v-chip>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-list class="pt-0" :color="getBackgroundColor(comment)">
            <v-card-text class="pa-0 pb-2 pr-4 pl-4">
              <div v-html="comment.text"></div>
              <FileChip :attachments="comment.attachments" :close="false" />
            </v-card-text>
          </v-list>
          <v-list
            v-if="!comment.isCustomerComment && desplayShowToCostomerBtn"
            color="cardBtnBadge"
          >
            <!-- checkbox -->
            <v-list-item-title
              class="pr-4 pl-4 d-block d-sm-flex justify-space-between"
            >
              <span class="body-2"> Mitt Trysilhus </span>
              <v-checkbox
                x-small
                class="pa-0 ma-0"
                v-model="comment.visibleToCustomer"
                label="Synlig for kunde"
                :disabled="comment.isCustomerComment"
                dense
                hide-details
                :ripple="false"
                @click="changeVisibleToCustomer(comment)"
              ></v-checkbox>
            </v-list-item-title>
            <!-- checkbox -->
          </v-list>
        </v-card>
      </div>
    </div>
    <div v-else>
      <div v-if="loading" class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-else>
        <v-card
          class="rounded-lg theme-shadow mb-3"
          :outlined="$vuetify.theme.dark"
          @click="$emit('addComment')"
        >
          <v-list color="cardSurface">
            <v-list-item class="pt-0 pb-0">
              <v-list-item-content class="pt-0 pb-0">
                Ingen kommentarer lagt til
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import contactpersonApi from "@/api/contactpersonApi";
import { mapGetters } from "vuex";
import FileChip from "@/components/shared/attachments/FileChip.vue";
// import commentsApi from "@/api/commentsApi";

export default Vue.extend({
  props: {
    comments: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    desplayShowToCostomerBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contactpersonApi,
    };
  },
  methods: {
    getBackgroundColor(comment) {
      return comment.visibleToCustomer
        ? comment.isCustomerComment
          ? "cardSurface"
          : "backgroundShadow"
        : "cardSurface";
    },
    getImageUrl(comment) {
      var tstamp = new Date().getTime();
      return (
        process.env.VUE_APP_APIURL +
        "/user/" +
        comment.commentedById +
        "/image/" +
        tstamp
      );
    },
    changeVisibleToCustomer(comment) {
      //   commentsApi.togglecustomervisibility(comment);
    },
  },
  computed: {
    ...mapGetters({
      profileImageUpdate: "shared/profileImageUpdate",
    }),
  },
  components: {
    FileChip,
  },
});
</script>

<style lang="scss" scoped>
.customerCommentBoarder {
  border-top: 3px solid var(--v-mt-base) !important;
}
.empoyeeCommentBoarder {
  border-top: 3px solid var(--v-yellow-base) !important;
}
</style>
